const permissions = {
  clientId: 'Client',
  menuId:'Menu',
  permissionKey:'PermissionKey',
  permissionName:'PermissionName',
  permissionType:'PermissionType',
  activeOff:'ActiveOff',
  remark:'Remark',
  addPermission:'AddPermission',
  editPermission:'EditPermission',
  bindButton:'BindPageOp',
  buttonPermission:'ButtonPermission',
  normalPermission:'NormalPermission',
  msg:{
    clientId:'Please select the Client',
    menuId:"Please select the Menu",
    permissionKey:'Please input the permissionKey',
    permissionName:'Please input the permissionName',
    permissionType:'Please select the PermissionType'
  }
};
export default permissions



// WEBPACK FOOTER //
// ./src/page/auth/permission/lang/permissions.en.js